import { useContext, useEffect, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import { isBC, isFinance } from "../../../../utils/jelim/CheckUserType";

const defaultTake = 10;

export const useAPIGetPackageRequest = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, requestPost, loading } = useAPIRequest();

  const employee = useSelector((state) => state.auth.employee);

  const UserType = employee ? employee.user_type : -1;

  const isBCUser = isBC(UserType);

  const [filterValue, setFilterValue] = useState({
    customer_id: null,
    data_customer: null,
    product_id: null,
    data_product: null,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });

  const [loadingMain, setLoadingMain] = useState(false);
  const [listData, setListData] = useState([]);

  //  API call section

  const fetchListData = async ({ page, take, filter }) => {
    let newFilter = filter ?? getFilter(filterValue);

    setLoadingMain(true);
    requestGet({
      fullUrl: `/api/customer/customerfreeproduct/data`,
      params: {
        page,
        take,
        filter: `${newFilter}`,
        order: "request_expired_date",
        order_method: "ASC",
        "with_customer,data_bc": 1,
        with_product: 1,
        with_approve_bc: 1,
      },
      onSuccess: ({ pagination, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter,
        });

        setListData(data.map((el, i) => ({
          ...el,
          no: (page - 1) * take + i + 1,
        })));
        setLoadingMain(false);
      },
      onError: ({ message }) => {
        uiContext.showErrorMsg("Error", message);
        setLoadingMain(false);
      },
    });
  };

  const handleApprove = async (row) => {
    requestPost({
      fullUrl: `/api/customer/customerfreeproduct/save`,
      body: {
        id: row.id,
        customer_id: row.customer_id,
        product_id: row.product_id,
        expired_date: isBCUser ? row.expired_date : row.request_expired_date,
        approve_bc_id: isBCUser ? employee.id : null,
        approve_bc_at: isBCUser ? format(new Date(), "yyyy-MM-dd HH:mm:ss") : null,
        quantity: row.quantity,
        usage_date: row.usage_date,
        type: row.type,
        description: row.description,
        request_expired_date: isBCUser ? row.request_expired_date : null,
      },
      onSuccess: ({ message }) => {
        uiContext.showSuccessMsg("Success", "Approved successfully");
        fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
      },
      onError: ({ message }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const handleReject = async (row) => {
    requestPost({
      fullUrl: `/api/customer/customerfreeproduct/save`,
      body: {
        id: row.id,
        customer_id: row.customer_id,
        product_id: row.product_id,
        expired_date: row.expired_date,
        quantity: row.quantity,
        usage_date: row.usage_date,
        type: row.type,
        description: row.description,
        request_expired_date: null,
        approve_bc_at: null,
        approve_bc_id: null,
      },
      onSuccess: ({ message }) => {
        uiContext.showSuccessMsg("Success", "Rejected successfully");
        fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
      },
      onError: ({ message }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    filterArr.push(`request_expired_date:!=:Null`);

    if (newFilterValue.customer_id) {
      filterArr.push(`customer_id:=:${newFilterValue.customer_id}`);
    }

    if (newFilterValue.product_id) {
      filterArr.push(`product_id:=:${newFilterValue.product_id}`);
    }

    if (isBCUser) {
      filterArr.push(`data_customer.bc_id:=:${employee.id};approve_bc_id:=:Null;approve_bc_at:=:Null`);
    } else {
      filterArr.push(`approve_bc_id:!=:Null;approve_bc_at:!=:Null`);
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: defaultTake });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnUpdateViewRow = (row) => {
    fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
  };

  const handleOnDeleteViewRow = (row) => {
    fetchListData({ page: paging.page, take: paging.take, filter: paging.filter });
  };

  return {
    loading,
    loadingMain,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
    handleApprove,
    handleReject,
  };
};
